<template>
  <div class="relative inline-block text-left">
    <div
      :id="`menu-button-${uuid}`"
      :class="['cursor-pointer', menuButtonClass]"
      :aria-expanded="show"
      :aria-controls="`dropdown-menu-${uuid}`"
      aria-haspopup="menu"
      @keydown="onKeydown"
      @click="show = !show"
    >
      <slot name="button" :aria-label="show ? 'Fermer le menu' : 'Ouvrir le menu'" />
    </div>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-if="show"
        :id="`dropdown-menu-${uuid}`"
        :class="[
          'absolute mt-2 p-2 shadow-xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-30',
          positionClass,
        ]"
        role="menu"
        aria-orientation="vertical"
      >
        <FocusTrap
          v-model:active="show"
          v-click-outside="onClickOutside"
          :initial-focus="() => $refs.itemsWrapper"
          @keydown.esc.stop="close"
        >
          <div ref="itemsWrapper">
            <slot name="items" />
          </div>
        </FocusTrap>
      </div>
    </transition>
  </div>
</template>

<script>
import { FocusTrap } from 'focus-trap-vue'

export default defineNuxtComponent({
  components: {
    FocusTrap,
  },
  props: {
    menuButtonClass: { type: String, default: null },
    positionClass: { type: String, default: 'origin-top-right right-0' },
    closeOnClick: { type: Boolean, default: true },
    closeOnClickOutside: { type: Boolean, default: true },
  },
  emits: ['close'],
  setup() {
    return {
      uuid: useId(),
    }
  },
  data() {
    return {
      show: false,
    }
  },
  watch: {
    show(value) {
      if (!value) {
        this.$emit('close')
      }
    },
  },
  methods: {
    close() {
      this.show = false
    },
    onKeydown(e) {
      // @todo: Handle keyboard navigation
    },
    onClickOutside() {
      if (this.closeOnClickOutside && this.show) {
        this.close()
      }
    },
  },
})
</script>
